























import { Component, Vue } from "vue-property-decorator";
import { IRootStoreState } from "../../store/root";
import { costCategoriesNames } from "../../store/core_table";

@Component
export default class CostFilter extends Vue {
  get allCostCategories(): string[] {
    return Object.values(costCategoriesNames);
  }

  get costCategoriesSelected(): string[] {
    return (this.$store.state as IRootStoreState).coreTableStore!
      .costCategoriesSelected;
  }
  set costCategoriesSelected(costCategories: string[]) {
    this.$store.commit(
      "coreTableStore/setCostCategoriesSelected",
      costCategories
    );
  }
}
